/**
 * 企業グループの色プリセットと表示クラスを集約する。
 * バックエンドの ALLOWED_COLORS と同期する 8 色。
 */

export const COMPANY_GROUP_COLORS = [
  "slate",
  "gray",
  "red",
  "orange",
  "amber",
  "lime",
  "sky",
  "violet",
] as const;

export type CompanyGroupColor = (typeof COMPANY_GROUP_COLORS)[number];

const COLOR_CLASS_MAP: Record<CompanyGroupColor, string> = {
  slate: "bg-slate-200 text-slate-800",
  gray: "bg-gray-200 text-gray-800",
  red: "bg-red-200 text-red-800",
  orange: "bg-orange-200 text-orange-800",
  amber: "bg-amber-200 text-amber-800",
  lime: "bg-lime-200 text-lime-800",
  sky: "bg-sky-200 text-sky-800",
  violet: "bg-violet-200 text-violet-800",
};

const FALLBACK_CLASS = "bg-slate-100 text-slate-700";

/**
 * 企業グループの ``color`` 値からバッジ表示用の Tailwind クラスを返す。
 * @param {string | null | undefined} color companyGroups.color の値
 * @return {string} Tailwind クラス文字列
 */
export function companyGroupColorClass(
  color: string | null | undefined,
): string {
  if (color == null) {
    return FALLBACK_CLASS;
  }
  return COLOR_CLASS_MAP[color as CompanyGroupColor] ?? FALLBACK_CLASS;
}
